import React from 'react';
import { useServicesContext } from '../../context';
import { OneCMSLayoutWrapper } from './StyledComponents.styles';
export const LayoutAdapter = ({ children }) => {
    const { getConfiguration } = useServicesContext();
    const enableOneCMSLayout = getConfiguration().enableOneCMSLayout;
    return enableOneCMSLayout ? (React.createElement(OneCMSLayoutWrapper, { "data-testid": "oneCMSWrapper" },
        React.createElement(React.Fragment, null, children))) : (React.createElement(React.Fragment, null, children));
};
